/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestBasicResponse } from '../../models/harvest-basic-response';

export interface GatHarvestBasicResponse$Params {
  facilityId: number;
}

export function gatHarvestBasicResponse(http: HttpClient, rootUrl: string, params: GatHarvestBasicResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestBasicResponse>>> {
  const rb = new RequestBuilder(rootUrl, gatHarvestBasicResponse.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestBasicResponse>>;
    })
  );
}

gatHarvestBasicResponse.PATH = '/api/facility/{facilityId}/harvest-basic-response';
